import {
  InlineDataService,
  InlineDataServiceContext,
  InlineDataServiceParams,
  InlineDataServiceResponse,
  InlineDatum,
} from '@stripe-internal/inline-data';

export const newInlineDataService = (
  apiFetch: typeof fetch,
  initialContext: InlineDataServiceContext = {},
): InlineDataService => {
  return {
    fetch: async (
      params: InlineDataServiceParams,
      serviceContext: InlineDataServiceContext = {},
    ): Promise<InlineDataServiceResponse> => {
      const {name, data} = params;
      const context = {...initialContext, ...serviceContext};

      const query = new URLSearchParams();
      query.set('name', name);

      Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value) {
          query.set(`data[${key}]`, value.toString());
        }
      });

      Object.keys(context).forEach((key) => {
        const value = context[key];
        if (value) {
          query.set(`context[${key}]`, value.toString());
        }
      });

      const requestACallResponse = await apiFetch(
        `/api/universal-help/inline-data?${decodeURIComponent(
          query.toString(),
        )}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      const code = requestACallResponse.status;

      if (requestACallResponse.ok) {
        const respData =
          (await requestACallResponse.json()) as Array<InlineDatum>;
        return {code, type: 'success', data: respData};
      } else {
        return {code, type: 'error', message: requestACallResponse.statusText};
      }
    },
    action: async (
      params: InlineDataServiceParams,
      serviceContext: InlineDataServiceContext = {},
    ): Promise<InlineDataServiceResponse> => {
      const {name, data} = params;
      const context = {...initialContext, ...serviceContext};
      const requestACallResponse = await apiFetch(
        '/api/universal-help/inline-data',
        {
          method: 'POST',
          body: JSON.stringify({
            name,
            data,
            context: {...context},
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      const code = requestACallResponse.status;

      if (requestACallResponse.ok) {
        const respData =
          (await requestACallResponse.json()) as Array<InlineDatum>;
        return {code, type: 'success', data: respData};
      } else {
        return {code, type: 'error', message: requestACallResponse.statusText};
      }
    },
  };
};
